import { style } from "@mui/system";
import React from "react";
import { Link } from "react-router-dom";
import {
  fleshStockSvg,
  fleshBashSvg,
  upLightSVG,
  downLightSVG,
} from "../SideBar/SideBarSvg";
import Cookies from "js-cookie";
export default function ElementSideDrop(props) {
  const theme = Cookies.get("theme");

  return (
    <Link to={props.to}>
      <div className="FlWd StHgt RlPs SmMarS ">
        {!props.reduce && (
          <span
            className={
              props.active
                ? theme == 0
                  ? "StAbs FlHg  StLanNlin BrdLft StTpNl WdSmP StTrns bgselectstockLight"
                  : "StAbs FlHg  StLanNlin BrdLft StTpNl WdSmP StTrns bgselectstock"
                : ""
            }
          ></span>
        )}
        <div
          className={
            props.active
              ? theme == 0
                ? "bgselectstockLight RglWdM FlHg StBrdRdS StTrns"
                : "bgselectstock RglWdM FlHg StBrdRdS StTrns"
              : "RglWdM FlHg StBrdRdS StTrns"
          }
        >
          <div
            className={
              "InFlx AlgnItm flxDrc FlHg FlWd " +
              (props.reduce ? "JstfCnt" : "")
            }
          >
            <div className="">
              <div className="InFlx">{props.icon}</div>
            </div>
            {!props.reduce && (
              <div className="FlHg InvStMrtg FlWd">
                <div className="TbDp RlPs FlWd FlHg InFlx spctwB AlgnItm">
                  <div className="TbCdp RlPs TxtCn VrAlg">
                    <span className="StSmlS">{props.text}</span>
                  </div>
                  {props.select ? (
                    <div
                      style={{
                        marginTop: "10px",
                        marginLeft: "80px",
                      }}
                    >
                      {theme == 0 ? upLightSVG : fleshStockSvg}
                    </div>
                  ) : (
                    <div
                      style={{
                        marginTop: "10px",
                        marginLeft: "80px",
                      }}
                    >
                      {theme == 0 ? downLightSVG : fleshBashSvg}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
